module.exports = __webpack_public_path__ + "images/e057e49b4b38f0ce3f7fe385c008ae53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/react/images/uerm/IND-KSS-1.jpg
// module id = 780
// module chunks = 0